import { request } from './http'
export function getContent(id) {
  return request({
    methods: 'post',
    url: '/my/api/agreement/detail',
    params: { id },
  })
}
